import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { markInitialNamespacesLoaded } from '@/hooks/useNamespace';

// ============================================================================
// INITIAL NAMESPACES (loaded synchronously, included in main bundle)
// Only load namespaces required for /auth and unauthenticated routes
// ============================================================================

// English - Initial namespaces only
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enLegal from './locales/en/legal.json';

// Swedish - Initial namespaces only
import svCommon from './locales/sv/common.json';
import svAuth from './locales/sv/auth.json';
import svLegal from './locales/sv/legal.json';

// ============================================================================
// LAZY NAMESPACES (loaded on-demand via useNamespace hook)
// - navigation, listings, offers, profile, admin, platform
// These are code-split and loaded when their respective routes are visited
// ============================================================================

export const supportedLanguages = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇬🇧' },
  { code: 'sv', label: 'Swedish', nativeLabel: 'Svenska', flag: '🇸🇪' },
] as const;

export type SupportedLanguage = typeof supportedLanguages[number]['code'];

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      auth: enAuth,
      legal: enLegal,
      // Lazy namespaces will be added via i18n.addResourceBundle()
    },
    sv: {
      common: svCommon,
      auth: svAuth,
      legal: svLegal,
      // Lazy namespaces will be added via i18n.addResourceBundle()
    },
  },
  lng: 'sv',
  fallbackLng: 'en',
  // All namespaces that can be used (some loaded lazily)
  ns: ['common', 'auth', 'legal', 'navigation', 'listings', 'offers', 'profile', 'admin', 'platform', 'allocations'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  // Return key if translation not found (fallback while lazy loading)
  returnEmptyString: false,
  returnNull: false,
});

// Mark initial namespaces as loaded so useNamespace knows not to re-import them
markInitialNamespacesLoaded();

export default i18n;
